/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Label, Button, Alert, InputGroup,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { useHistory } from 'react-router-dom';

import {
  Formik, Field, Form, ErrorMessage,
} from 'formik';
import * as Yup from 'yup';
import { isNull } from 'lodash';
import { get, post } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';
import BaseGrid from '../Common/BaseGrid';

function TesterForm(props) {
  const {
    entity,
    t,
  } = props;

  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const save = async (values) => {
    try {
      setLoading(true);

      let result = null;
      if (entity.id !== undefined) {
        result = await post(`/api/testers/save/${entity.id}`, values);
      } else {
        result = await post('/api/testers/create', values);
      }
      setErrorMessage(null);

      toastr.success(t(`Tester ID ${result.id} saved`), t('Success'));
      props.onSuccess(result);
    } catch (error) {
      setErrorMessage(`${error.message}: ${error.response.data}`);
    } finally {
      setLoading(false);
    }
  };

  const ValidationSchema = Yup.object().shape({
    version: Yup.string().nullable(),
    location: Yup.string().nullable(),
    serial_number: Yup.string().nullable(),
    panel: Yup.string().nullable(),
    mb_family: Yup.string().nullable(),
    condition: Yup.string().nullable(),
    notes: Yup.string().nullable(),
    device_id: Yup.number(),
    device: Yup.object().shape({
      id: Yup.number().required(t('Device is required')),
    }),
  });

  let em = (
    <Alert color="danger" className="mt-3" isOpen={!isNull(errorMessage)}>
      {errorMessage}
    </Alert>
  );

  if (errorMessage != null) { // Make part bold
    const match = errorMessage.match(/(.*)<<<(.+)>>>(.*)/);

    if (match !== null) {
      em = (
        <Alert color="danger" className="mt-3" isOpen>
          {match[1]}
          <strong>{match[2]}</strong>
          {match[3]}
        </Alert>
      );
    }
  }

  const jsx = (
    <>
      { em }
      <Formik
        enableReinitialize
        initialValues={entity}
        validationSchema={ValidationSchema}
        onSubmit={(values) => {
          save(values);
        }}
      >
        {({
          touched, errors, values, setFieldValue,
        }) => (
          <Form className="mt-3" id="TesterForm" autoComplete="off">
            {Object.entries(errors).length > 0 && (
              <Alert color="danger">{t('Form contains errors')}</Alert>
            )}
            {values.device == null && (
              <Row>
                <Label
                  for="device"
                  className="col-sm-2 col-form-label"
                >
                  {props.t('Device')}
                </Label>
                <Col md="8">
                  <BaseGrid
                    url={url.GET_DEVICES}
                    hasSearch
                    config={
                    {
                      columns: {
                        id: { label: props.t('ID'), sort: true },
                        type: { label: props.t('Type'), sort: true },
                        source: { label: props.t('Brand'), sort: true },
                        identifier: { label: props.t('Model'), sort: true },
                        actions: {
                          label: props.t('Actions'),
                          actions: [
                            {
                              key: 'edit',
                              icon: 'mdi mdi-check-bold',
                              class: 'btn btn-sm btn-soft-dark',
                              alt: props.t('Select'),
                              click: (d) => {
                                setFieldValue('device', d);
                                setFieldValue('device_id', d.id);
                              },
                            },
                          ],
                        },
                      },
                      pagination: {
                        sort: 'id',
                        direction: 'desc',
                        perPage: 5,
                      },
                    }
                    }
                  />
                </Col>
              </Row>
            )}

            {values.device != null && (
              <div className="row mt-4 mb-4">
                <Label
                  for="device"
                  className="col-sm-2 col-form-label"
                >
                  {props.t('Device')}
                </Label>
                <Col sm={8}>
                  <Field name="device.id" type="hidden" className="form-control" />
                  <InputGroup>
                    <input type="text" className="form-control" value={`${values.device.source} ${values.device.identifier}`} readOnly />
                    <Button
                      type="button"
                      onClick={() => { setFieldValue('device', null); setFieldValue('device_id', null); }}
                      color="danger"
                      className="btn-soft-danger"
                    >
                      <span className="mdi mdi-close-thick" />
                    </Button>
                  </InputGroup>
                  <ErrorMessage
                    name="device_id"
                    component="div"
                    className="text-danger"
                  />
                </Col>
              </div>
            )}

            <div className="row mt-4 mb-4">
              <Label
                for="version"
                className="col-sm-2 col-form-label"
              >
                {props.t('Version')}
              </Label>
              <Col sm={8}>
                <Field
                  type="text"
                  className={`form-control ${(errors.version && touched.version ? 'is-invalid' : '')}`}
                  id="version"
                  name="version"
                />
                <ErrorMessage
                  name="version"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>
            <div className="row mt-4 mb-4">
              <Label
                for="serial"
                className="col-sm-2 col-form-label"
              >
                {props.t('Serial')}
              </Label>
              <Col sm={8}>
                <Field
                  type="text"
                  className={`form-control ${(errors.serial && touched.serial ? 'is-invalid' : '')}`}
                  id="serial"
                  name="serial_number"
                />
                <ErrorMessage
                  name="serial_number"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="location"
                className="col-sm-2 col-form-label"
              >
                {props.t('Location')}
              </Label>
              <Col sm={8}>
                <Field
                  type="text"
                  className={`form-control ${(errors.location && touched.location ? 'is-invalid' : '')}`}
                  id="location"
                  name="location"
                />
                <ErrorMessage
                  name="location"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="panel"
                className="col-sm-2 col-form-label"
              >
                {props.t('Panel')}
              </Label>
              <Col sm={8}>
                <Field
                  type="text"
                  className={`form-control ${(errors.panel && touched.panel ? 'is-invalid' : '')}`}
                  id="panel"
                  name="panel"
                />
                <ErrorMessage
                  name="panel"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="mb_family"
                className="col-sm-2 col-form-label"
              >
                {props.t('Family')}
              </Label>
              <Col sm={8}>
                <Field
                  type="text"
                  className={`form-control ${(errors.mb_family && touched.mb_family ? 'is-invalid' : '')}`}
                  id="mb_family"
                  name="mb_family"
                />
                <ErrorMessage
                  name="mb_family"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="condition"
                className="col-sm-2 col-form-label"
              >
                {props.t('Condition')}
              </Label>
              <Col sm={8}>
                <Field
                  type="text"
                  className={`form-control ${(errors.condition && touched.condition ? 'is-invalid' : '')}`}
                  id="condition"
                  name="condition"
                />
                <ErrorMessage
                  name="condition"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>

            <div className="row mt-4 mb-4">
              <Label
                for="notes"
                className="col-sm-2 col-form-label"
              >
                {props.t('Notes')}
              </Label>
              <Col sm={8}>
                <Field
                  type="text"
                  as="textarea"
                  className={`form-control ${(errors.notes && touched.notes ? 'is-invalid' : '')}`}
                  id="notes"
                  name="notes"
                />
                <ErrorMessage
                  name="notes"
                  component="div"
                  className="text-danger"
                />
              </Col>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );

  return jsx;
}

TesterForm.defaultProps = {
  entity: {
    notes: '',
    mb_family: '',
    panel: '',
    location: '',
    serial_number: '',
    version: '',
  },
  onSuccess: () => {},
};

TesterForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  entity: PropTypes.object,
  onSuccess: PropTypes.func,
};

export default connect((state) => ({

}), {})(withTranslation()(TesterForm));
